
import util from '../../util/Util';
const StarRating  = () => import('vue-star-rating');
export default {
  components:{
    StarRating
  },
  props: {
    modalShow: {
      type: Boolean,
      default: false
    },
    jobId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showRating:false,
      isModalVisible: false,
      review: {
        rating: 5,
        description: ''
      }
    }
  },
  computed:{
    currentUser() {
      return this.$store.state.user;
    }
  },
  created() {
    this.isModalVisible = this.modalShow
    this.showRating = true;
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submitReview() {
      const payload = {
        jobId: this.jobId,
        review: this.review,
        user: this.currentUser
      }
      this.$store.dispatch('review/submitReview', payload)
        .then(() => {
          this.$toast.success('Review Successfully Submitted').goAway(3000);
          this.$emit('submit-close');
        })
        .catch(() => {
          this.$toast.error('Failed to Submit Review - Contact support@utransport.com.au').goAway(5000);
        });
    }
  }
}
